import { transaction } from "mobx";

export default class BottomSheet {
  constructor(makeMobxStore) {
    this.reset = makeMobxStore(this);
  }
  // actions
  set = {
    open: (open = false) => {
      this.open = open;
    },
    onClose: (onClose = () => this.set.open()) => {
      this.onClose = onClose;
    },
    Component: (Component = () => null) => {
      this.Component = Component;
    },
    state: (state = {}) => {
      this.state = state;
    },
    sx: (sx = {}) => {
      this.sx = sx;
    }
  };
  configure = Component => {
    transaction(() => {
      if (this.open) {
        // if open, close
        this.set.open(false);
        // wait for close, then mount and open next bottom sheet
        setTimeout(() => {
          this.set.Component(Component);
          this.set.open(true);
        }, 600);
      } else {
        // if closed, mount and open
        this.set.Component(Component);
        this.set.open(true);
      }
    });
  };
  toggle = () => this.set.open(!this.open);
}
